(function($) {
    $(function() {
        $('.mixed-slideshow').each(function (index) {
			var $slider = $(this);
            var slideCount = $slider.find('.swiper-slide').length;
    
            $slider
                .find('.mixed-slideshow__swiper')
                .addClass('mixed-slideshow__swiper--' + index);
    
            var swiper = new Swiper('.mixed-slideshow__swiper--' + index, {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
    
			if($slider.find('.isRight') != null && $slider.find('.isRight').length > 0)
			{
				$slider
					.find('.mixed-slideshow__controls')
					.prependTo($slider);
			}
			else
			{
				$slider
					.find('.mixed-slideshow__controls')
					.appendTo($slider);
			}
	
            

            // Loop back on first slide and last slide
            var prevBtnDisabled = false;
            var nextBtnDisabled = false;
            
            $slider.find('.swiper-button-next, .swiper-button-prev').on('mousedown', function (e) {
                if ( $(this).hasClass('swiper-button-next') && $(this).hasClass('swiper-button-disabled')) {
                    nextBtnDisabled = true;
                } 
                if ( $(this).hasClass('swiper-button-prev') && $(this).hasClass('swiper-button-disabled')) {
                    prevBtnDisabled = true;
                } 
            });

            $slider.find('.swiper-button-next, .swiper-button-prev').on('click', function (e) {
                if (nextBtnDisabled) {
                    swiper.slideTo(0);
                    nextBtnDisabled = false;
                }
                
                if (prevBtnDisabled) {
                    swiper.slideTo(slideCount);
                    prevBtnDisabled = false;
                }
            });
        });
    });
})(jQuery);